import * as React from 'react'
import glamorous from 'glamorous'
import { InjectedFormikProps } from 'formik'

import { Props } from '../../pages/Login/TwoFact'
import { Values } from '../../../containers/pages/LoginForm/TwoFactForm'

import { Alert } from '../../common/Alert/Alert'
import { Input } from '../../common/Input/Input'
import { SubmitButton } from '../../common/SubmitButton/SubmitButton'

import { FormTitle } from './components/FormTitle/FormTitle'
import { Form } from './components/Form/Form'

import { StyledLoginForm } from './LoginForm.glamorous'
import { get } from 'lodash'

export const StyledInput = glamorous(Input)({
  padding: '0 80px 20px',
})

export const LastStyledInput = glamorous(StyledInput)({
  padding: '0 80px 40px',
})

export class TwoFactForm extends React.Component<InjectedFormikProps<Props, Values>> {

  handleFocus = (event: any) => event.target.previousSibling.classList += ' active'

  render() {
    return (
      <StyledLoginForm>

        <FormTitle>Two Factor Athuentication</FormTitle>

        {(!!Object.keys(this.props.errors).length && !!Object.keys(this.props.touched).length) && (
          Object.keys(this.props.errors).filter(
            (msg) => Object.keys(this.props.touched).includes(msg)).map((error, idx) => {
              const msg = this.props.errors[error]
              return (
                <Alert type="error">
                  <p key={`${error}${idx}`}>{`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`}</p>
                </Alert>
              )
            })
        )}

        {(this.props.userError)
          ? (<Alert type="error"><p key={0}>
            {`${get(this.props, 'userError', 'Invalid Code')}`}</p></Alert>)
          : null}

        {(this.props.recoverSuccess)
          ? (<Alert type="success"><p>Thank you, your password has been reset, please log in to continue.</p></Alert>)
          : null}

        <Form onSubmit={this.props.handleSubmit}>

          <StyledInput
            error={this.props.touched.two_fact_key && this.props.errors.hasOwnProperty('two_fact_key')}
            id="two_fact_key"
            label="Two Factor Athuentication Key"
            onBlur={this.props.handleBlur}
            onChange={this.props.handleChange}
            placeholder="Key"
            required={true}
            tabIndex={1}
            type="text"
            value={this.props.values.two_fact_key}
            autoComplete="nope"
            onFocus={(event) => this.handleFocus(event)}
          />
          <SubmitButton
            disabled={!this.props.isValid || this.props.isSubmitting}
            type="submit"
          >
            Login
          </SubmitButton>
        </Form>
      </StyledLoginForm>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/LoginForm/TwoFactForm.tsx